import DOMPurify from 'dompurify';

/**
 * Get the parameters.
 * @param  {string} blockId the block id.
 */
export const getParams = (block) => {
	const urlParams = new URLSearchParams(window.location.search);
	const filterContainer = block.querySelector('.wp-block-embark-filterable-content__filter-container');
	const params = {};
	const { dataset } = filterContainer;

	urlParams.forEach((value, key) => {
		key = DOMPurify.sanitize(key); // Sanitize the key.
		value = DOMPurify.sanitize(value); // Sanitize the value.
		params[key] = value;
		if (key === 'paged') {
			filterContainer.dataset.paged = value; // Sanitize before setting it in the dataset.
		}
	});

	// Set default parameters from the block filter container.
	const defaultParams = {
		block: block.id,
		...dataset,
	};

	Object.keys(defaultParams).forEach((key) => {
		params[key] = DOMPurify.sanitize(defaultParams[key]);
	});

	// console.log('params', params);

	return params;
};

export const setParams = (block, extraParams = {}) => {
	const filterContainer = block.querySelector('.wp-block-embark-filterable-content__filter-container');
	const inputs = block.querySelectorAll('[type="checkbox"], [name="search"], select');
	const params = {
		paged: filterContainer.dataset.paged,
		...extraParams,
	};

	// Loop through the inputs and get the set values.
	inputs.forEach((e) => {
		const {
			checked,
			classList,
			dataset,
			value,
			name,
		} = e;
		const { tax } = dataset;

		// If is checked, set the tax parameters and sanitize the value
		if (checked && tax) {
			const sanitizedValue = DOMPurify.sanitize(value);
			if (params[tax] !== undefined) {
				params[tax].push(sanitizedValue);
			} else {
				params[tax] = [sanitizedValue];
			}
		}

		// If is search, set the search parameter and sanitize the value
		if (classList.contains('filter-search') && value) {
			params.search = DOMPurify.sanitize(value);
		}

		if (name === 'orderby' && value) {
			filterContainer.dataset.orderby = DOMPurify.sanitize(value);
			params.orderby = DOMPurify.sanitize(value);
		}
	});

	const query = new URLSearchParams(params).toString();
	let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
	if (query) {
		newUrl += `?${DOMPurify.sanitize(query)}`; // Sanitize the query string before adding it to the URL
	}
	window.history.pushState({ path: newUrl }, '', newUrl);
};
